import { useQueryClient } from '@tanstack/react-query';
import * as R from 'ramda';
import { DataQueryKey } from '../../../../hooks/useDataQuery/dataQuery.types';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';

const useRemoveProductGridQueries = () => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();

  return (productColorIds: string[]) => {
    R.uniq(productColorIds).forEach((productColorId) => {
      queryClient.removeQueries({
        queryKey: [team?.id, DataQueryKey.PRODUCT_GRID, productColorId],
      });
    });
  };
};

export default useRemoveProductGridQueries;
